/**
 * Переход на другую страницу целиком — между системой администрирования
 * и кабинетом разборки (задача 0042).
 *
 * <p>Целиком, а не сменой экрана: у кабинета своя сессия, свои справочники
 * и своё локальное хранилище, привязанное к компании, и всё это поднимает
 * загрузка приложения, а не переключение вкладки.
 *
 * <p>Объектом, а не голой функцией: тест подменяет переход (`vi.spyOn`),
 * а `window.location.assign` в jsdom подменить нечем — свойство
 * не переопределяется.
 */
export const navigation = {
  go(path: string): void {
    window.location.assign(path);
  },
};
